import { getFormattedDateString } from 'lib/DateTime';
import {
  MSNBC_TVE_PID,
  NEWS_NOW_PID,
  TODAY_ALL_DAY_PID,
} from 'lib/playmaker';

const DATE_OPTIONS = { format: 'd M D', useAP: false, commaAfterDay: false };

export const METADATA_DEFAULTS = (vertical) => {
  const shared = {
    playmakerArt: null,
    playmakerAutoplayMuted: true,
    playmakerPlayBehavior: 'clickToPlay',
    playmakerDescription: null,
  };
  switch (vertical) {
    case 'msnbc':
      return {
        ...shared,
        playmakerId: MSNBC_TVE_PID,
        playmakerTitle: false, // Override in curation or use schedule data
      };
    case 'today':
      return {
        ...shared,
        playmakerId: TODAY_ALL_DAY_PID,
        playmakerTitle: 'Today All Day',
        playmakerDescription: 'Watch TODAY All Day. A streaming channel from TODAY.',
        playmakerArt: 'today_all_day_tease',
      };
    default:
      return {
        ...shared,
        playmakerId: NEWS_NOW_PID,
        playmakerTitle: `NBC News NOW for ${getFormattedDateString(Date.now(), null, DATE_OPTIONS)}`,
        playmakerDescription: 'NBC News NOW is a streaming network from NBC News. NOW features deep reporting, thoughtful storytelling, and live, breaking news from the global resources of NBC News.',
        playmakerArt: 'news-now-opening',
      };
  }
};

const mergeOverride = (defaultValue, override) => (
  defaultValue === 'other'
    ? override
    : defaultValue
);

export function getPlaymakerMetadata(metadata, vertical = 'nbcnews') {
  const {
    playmakerToggle,
    playmakerId,
    playmakerIdOverride,
    playmakerArt,
    playmakerArtOverride,
    ...rest
  } = {
    ...METADATA_DEFAULTS(vertical),
    ...metadata,
  };

  // Playmaker is turned OFF
  if (playmakerToggle !== true) return { playmakerToggle };

  // Playmaker is turned ON
  return {
    ...rest,

    playmakerToggle,

    // There are two inputs for Playmaker ID (a select and a textbox for injecting new pids)
    playmakerId: mergeOverride(playmakerId, playmakerIdOverride),

    // There are two inputs for Playmaker Art (a select and a textbox for injecting new guids)
    playmakerArt: mergeOverride(playmakerArt, playmakerArtOverride),
  };
}
